import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
  } from "react";
  import useSetParamsURL from "../../../../../lib/useSetParamsURL";
import DialogDetalheCheque from "./DialogDetalheCheque";
  
  interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void;
  }
  
  const ModalDetalheChequeContext = createContext<ModalContextType | undefined>(
    undefined
  );
  
  export const ModalDetalheChequeProvider: React.FC<{ children: ReactNode }> = ({
    children,
  }) => {
    const { searchParams, clearSingleParamUrl } = useSetParamsURL();
    const codigo = searchParams.get("detalhe-cheque");
  
    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);
  
    const openModal = (content: string) => {
      setItemValue(content);
      setIsOpen(true);
    };
  
    const closeModal = () => {
      setIsOpen(false);
      setItemValue(null);
      clearSingleParamUrl("detalhe-cheque");
    };
  
    useEffect(() => {
      if (codigo) setItemValue(codigo);
    }, [codigo]);
  
    return (
      <ModalDetalheChequeContext.Provider value={{ openModal, closeModal }}>
        {children}
  
        {itemValue && isOpen && (
          <DialogDetalheCheque
            open={isOpen}
            id={itemValue}
            handleClose={closeModal}
          />
        )}
      </ModalDetalheChequeContext.Provider>
    );
  };
  
  export const useModalDetalheCheque = (): ModalContextType => {
    const context = useContext(ModalDetalheChequeContext);
    if (!context) throw new Error("useModal must be used within a ModalProvider");
    return context;
  };
  